import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function YoutubeVideos({ videos = [] }) {
  return (
    <div className='youtube-videos'>
      <h1 className='main-title'>This is a Work of Fiction</h1>
      <p className='subtitle'>
        A series about a woman who gives herself a year to decide if life is
        worth living.
      </p>

      <div className='video-grid'>
        {videos.map((video, index) => {
          const episodeTitle =
            index === 12 ? 'Interlude' : `Episode ${index + 1}`;
          return (
            <div key={video.id} className='video-item'>
              <Link to={`/watch/${video.id}`} className='video-link'>
                <div className='thumbnail-container'>
                  <img
                    src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                    alt={`Thumbnail for ${episodeTitle}`}
                    className='video-thumbnail'
                  />
                  <div className='play-button'>▶</div>
                </div>
                <h4>{episodeTitle}</h4>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default YoutubeVideos;
